import styled from 'styled-components';

import { body } from '@constants/fonts';

export const FlexBox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: nowrap;
  font-size: 30px;
  padding-right: 10px;
  margin-bottom: 5px;
  font-weight: 500;
  font-family: ${body};
  .welcome-msg-start {
    color: ${({ theme }) => theme.palette.text.primary};
  }
  .welcome-msg-name {
    color: ${({ theme }) => theme.palette.primary.main};
  }

  ${(props) => props.theme.breakpoints.down('sm')} {
    font-size: 24pt;
    padding-right: 0px;
  }
`;
export const TimeIndicator = styled.div`
  display: flex;
  margin-left: 10px;
`;

export const Dot = styled.span`
  color: ${({ theme }) => theme.palette.text.primary};
  &:after {
    content: '.';
  }
`;
